import Backbone from "backbone";
import * as exportDialog from "exportDialog";
import * as mustcache from "mustcache";
import SelectionActionList from "SelectionActionList";
import * as languageMap from "shared/languageMap";
import * as _ from "underscore";
import PaginationControlsView from "views/PaginationControlsView";
import SelectAllView from "views/SelectAllView";
import SelectionActionView from "views/SelectionActionView";
import SelectView from "views/SelectView";
import SelectWholeCollectionView from "views/SelectWholeCollectionView";
import UndoDeleteView from "views/UndoDeleteView";

const RemoteWordListToolbarView = Backbone.View.extend({
  tagName: "div",
  className: "wordsToolbar",
  initialize: function (options) {
    this.options = options || {};
    this.render();
  },
  render: function () {
    const that = this;
    this.$el.html(mustcache.render("wordListToolbar"));

    this.sortByLabel = this.$el.find(".sortByLabel");

    this.listenTo(this.model.searchQuery, "change", () => {
      if (that.model.searchQuery.get("wordGroup") === "deleted") {
        that.sortByLabel.hide();
      } else {
        that.sortByLabel.show();
      }
    });

    this.views = {};
    this.views.selectAllView = new SelectAllView({
      model: this.model.selectionModel,
      el: this.$el.find(".selectAllContainer"),
    });
    this.views.selectWholeCollectionView = new SelectWholeCollectionView({
      model: this.model.selectionModel,
      el: this.$el.find(".selectWholeGroup"),
    });
    this.views.undoDeleteView = new UndoDeleteView({
      model: this.model,
      el: this.$el.find(".undoDelete"),
    });
    this.views.selectionActionView = new SelectionActionView({
      model: this.model.selectionModel,
      name: "Actions",
      heading: "Perform action",
      el: this.$el.find(".actions.dropdown"),
      selectionActionList: new SelectionActionList(
        [
          {
            id: "delete",
            name: "Delete",
            applyQuery: {
              $and: [
                { deleted: { $ne: true } },
                { wordGroup: { $ne: "deleted" } },
              ],
            },
          },
          {
            id: "undelete",
            name: "Un-Delete",
            applyQuery: {
              $or: [{ deleted: true }, { wordGroup: "deleted" }],
            },
          },
          {
            id: "permDelete",
            name: "Permanently Delete",
            applyQuery: {
              $or: [{ deleted: true }, { wordGroup: "deleted" }],
            },
          },
          {
            id: "export",
            name: "Export",
            exec: function () {
              exportDialog.show(that.model, that.options.models);
            },
          },
          {
            id: "flashcards",
            name: "Practice Flashcards",
            exec: () => {
              this.options.appRouter.navigate(
                "/" +
                  this.model.first().get("language") +
                  "/flashcards/word/" +
                  this.model.selectionModel.get("itemIDs").join("|"),
                { trigger: true }
              );
            },
          },
        ],
        { selectionModel: this.model.selectionModel }
      ),
    });

    let sortByOptions = [
      {
        value: "lastModified",
        text: "Recently Modified",
      },
      {
        value: "lastPracticed",
        text: "Recently Practiced",
      },
      {
        value: "new",
        text: "Recently Added",
      },
      {
        value: "old",
        text: "Oldest",
      },
    ];

    if (
      languageMap.map[that.options.models.user.get("currentLearningLanguage")]
        .frequencies
    ) {
      sortByOptions = sortByOptions.concat([
        {
          value: "frequency",
          text: "Usefulness / Frequency",
        },
        {
          value: "relevancy",
          text: "Relevancy",
        },
      ]);
    }

    this.views.sortBySelectorView = new SelectView({
      el: this.$el.find(".sortBySelector"),
      model: this.model.searchQuery,
      field: "sortBy",
      options: sortByOptions,
    });
    this.views.paginationControls = new PaginationControlsView({
      el: this.$el.find(".paginationControls"),
      model: this.model,
    });
  },
  remove: function () {
    _.each(this.views, (view) => {
      view.remove();
    });
    delete this.views;
  },
});

export default RemoteWordListToolbarView;
